import React, { useState, useContext, useEffect } from "react";

import "./FillGaps.css";

const answers = [
  "Спутник планеты Земля - ",
  "Солнце - это ",
  "another item text",
];

const FillGaps = ({ question, setAnswers, currentAnswer }) => {
  const [textsArray, setTextsArray] = useState([]);
  const [questionProcessed, setQuestionProcessed] = useState([]);

  console.log(currentAnswer);

  useEffect(() => {
    const arrayText = question
      .split(" ")
      .map(function (item) {
        // console.log(item)
        return item.trim();
      })
      .filter((item) => item !== "");
    setQuestionProcessed(arrayText);
    if (currentAnswer) {
      let newText = [];
      let answerArray = [...currentAnswer];
      for (let i = 0; i < arrayText.length; i++) {
        if (arrayText[i].match(/<[0-9]>/)) {
          newText.push(answerArray[0].toLowerCase());
          answerArray.splice(0, 1);
        } else {
          newText.push("");
        }
      }
      // console.log(newText)
      setTextsArray(newText);
    } else {
      setTextsArray(new Array(arrayText.length).fill(""));
    }
  }, [question]);

  const collectTexts = (value, index) => {
    setTextsArray(
      textsArray.map((answer, i) => (i !== index ? answer : value))
    );
  };

  useEffect(() => {
    setAnswers(textsArray.filter((i) => i !== ""));
  }, [textsArray]);

  console.log(textsArray);
  return (
    <div className="fillGaps__container">
      {/* {questionProcessed &&
                questionProcessed.map((line, index) => (
                    line !== '' &&
                    <div className='fillGaps__item' key={index}>
                        <p className='fillGaps__text'>{line}</p>
                        <input className='fillGaps__input' type='text' onChange={(e) => collectTexts(e.target.value, index)} value={textsArray[index]} />
                    </div>
                ))} */}
      {questionProcessed &&
        questionProcessed.map(
          (line, index) =>
            line !== "" && (
              <div className="fillGaps__item" key={index}>
                {!/<[0-9]>/.test(line) && (
                  <p className="fillGaps__text">{line}</p>
                )}
                {/<[0-9]>/.test(line) && (
                  <input
                    className="fillGaps__input"
                    type="text"
                    onChange={(e) => collectTexts(e.target.value, index)}
                    value={textsArray[index]}
                  />
                )}
              </div>
            )
        )}
    </div>
  );
};

export default FillGaps;
